import employeeSvg from "@/assets/svg/employee.svg";

export default {
  path: "/employee",
  redirect: "/employee/index",
  meta: {
    icon: employeeSvg,
    title: "员工管理",
    rank: 4
  },
  children: [
    {
      path: "/employee/index",
      name: "employee",
      component: () => import("@/views/employee/index.vue"),
      meta: {
        title: "员工管理",
        keepAlive: false,
        roles: ["employee"]
      }
    }
  ]
} as RouteConfigsTable;
